import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { CourseDetailPage } from './pages/CourseDetailPage';
import { AboutCenterPage } from './pages/AboutCenterPage';
import { AllCoursesPage } from './pages/AllCoursesPage';
import { SatguruBioPage } from './pages/SatguruBioPage';
import { VolunteerPage } from './pages/VolunteerPage';
import { DonatePage } from './pages/DonatePage';
import { FAQPage } from './pages/FAQPage';
import { TeamPage } from './pages/TeamPage';
import { ContactPage } from './pages/ContactPage';
import { FacilitiesPage } from './pages/FacilitiesPage';
import { StartJourneyPage } from './pages/StartJourneyPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/course/awakening-inner-light" element={<CourseDetailPage data-id="element-5" />} data-id="element-4" />
        <Route path="/about" element={<AboutCenterPage data-id="element-7" />} data-id="element-6" />
        <Route path="/courses" element={<AllCoursesPage data-id="element-9" />} data-id="element-8" />
        <Route path="/satguru" element={<SatguruBioPage data-id="element-11" />} data-id="element-10" />
        <Route path="/volunteer" element={<VolunteerPage data-id="element-13" />} data-id="element-12" />
        <Route path="/donate" element={<DonatePage data-id="element-15" />} data-id="element-14" />
        <Route path="/faq" element={<FAQPage data-id="element-17" />} data-id="element-16" />
        <Route path="/team" element={<TeamPage data-id="element-19" />} data-id="element-18" />
        <Route path="/contact" element={<ContactPage data-id="element-21" />} data-id="element-20" />
        <Route path="/facilities" element={<FacilitiesPage data-id="element-23" />} data-id="element-22" />
        <Route path="/start-journey" element={<StartJourneyPage data-id="element-25" />} data-id="element-24" />
      </Routes>
    </Router>;
}